import React from 'react';
import type { ReactNode } from 'react';

interface GradientProps {
  children: ReactNode;
  variant?: 'hero' | 'contact';
  className?: string;
  id?: string;
}

export function Gradient({ 
  children, 
  variant = 'hero',
  className = '',
  id
}: GradientProps): JSX.Element {
  return (
    <div className={`relative ${className}`} id={id}>
      {variant === 'hero' && (
        <>
          <div className="absolute inset-0 bg-gradient-to-t to-background from-orange-100/60 dark:from-orange-950 dark:via-transparent dark:to-background"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-eggshell-50 via-transparent to-transparent dark:from-background dark:via-transparent dark:to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-l from-eggshell-50 via-transparent to-transparent dark:from-background dark:via-transparent dark:to-transparent"></div>
        </>
      )}
      
      {variant === 'contact' && (
        <>
          <div className="absolute inset-0 bg-gradient-to-t to-white from-background dark:from-background dark:via-transparent dark:to-black"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-eggshell-50 via-transparent to-transparent dark:from-background dark:via-transparent dark:to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-l from-eggshell-50 via-transparent to-transparent dark:from-background dark:via-transparent dark:to-transparent"></div>
        </>
      )}
      
      <div className="relative">{children}</div>
    </div>
  );
} 